import { render } from "./ViewTopNav.vue?vue&type=template&id=5f8b96f6"
import script from "./ViewTopNav.vue?vue&type=script&lang=js"
export * from "./ViewTopNav.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ranjanbajracharya/Documents/Upwork/kaz/plus studio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__